import React from 'react';
import { Grid, Container, Text, Icon, Flex, Link } from 'basis';
import { PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE, config, OverviewSources } from '_config';
import { EarnRateTiers, EarnRateDisclaimer, getAnnualFeeWaiverBenefits } from 'components';
import { useStoreValue } from 'store';
import { useDataLayerAndAnalyticsLinks } from 'hooks';
import { getRatesAndFees, isFeatureOn } from 'featureToggles';
import { LandingContentItem } from './LandingPageDJ.styles';

export const ProsAndCons = () => {
  const [storeState] = useStoreValue();
  const { trackEventSender } = useDataLayerAndAnalyticsLinks(storeState);

  const learnMoreLink = (
    <Link
      newTab
      href={OverviewSources.AU.learnMore.url}
      onClick={() =>
        trackEventSender({
          location: 'landing',
          action: 'external-link',
          label: OverviewSources.AU.learnMore.label,
        })
      }
    >
      {OverviewSources.AU.learnMore.label}
    </Link>
  );

  const content = {
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: {
      pros: [
        'A lower credit card fee than the David Jones Prestige credit card.',
        ...(isFeatureOn('cvpV2') ? getAnnualFeeWaiverBenefits(PRODUCT_CODE_DAVID_JONES_PREMIERE) : []),
        {
          text: 'Earn David Jones Points -',
          showEarnRates: true,
        },
        'Access to David Jones sales, previews, complimentary express delivery, gift wrapping and more.',
        'Minimum credit limit is $1,000.',
      ],
      cons: [
        'Complimentary travel insurance not included.',
        'Additional cardholder available for a fee.',
        'If you have an existing David Jones credit card or David Jones store card, you don’t need to apply.',
      ],
    },
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: {
      pros: [
        ...(isFeatureOn('cvpV2') ? getAnnualFeeWaiverBenefits(PRODUCT_CODE_DAVID_JONES_PRESTIGE) : []),
        {
          text: 'Earn David Jones Points quicker -',
          showEarnRates: true,
        },
        'Complimentary travel insurance',
        'Access to two airport lounge passes each year.',
        'Exclusive access to David Jones sales, previews and events, complimentary same day delivery, gift wrapping and more.',
      ],
      cons: [
        `A higher credit card fee ($${getRatesAndFees().annualFee}) than the David Jones Premiere credit card.${
          isFeatureOn('cvp')
            ? ' Effective 25 August 2026 the annual David Jones Prestige credit card fee will be $345. Waived for your first year.'
            : ''
        }`,
        'Minimum credit limit requirement of $6,000.',
        'If you have an existing David Jones credit card or David Jones store card, you don’t need to apply.',
      ],
    },
  };

  return (
    <Grid colsGutter="0" cols="6" colsGap="6" colSpan="4" rowsGap-md="10">
      <Grid.Item colSpan="all" colSpan-md="0-2" colSpan-lg="0-2" rowSpan="0" rowSpan-md="0" margin-md="0">
        <Container margin="0 0 3 0" margin-md="0 0 6 0" padding="0">
          <Text textStyle="heading5">Features & Benefits</Text>
        </Container>
        {content[config.productCode]?.pros?.map((item, index) =>
          item.showEarnRates ? (
            <LandingContentItem key={index}>
              <div>
                <Flex>
                  <div>
                    <Icon name="tick" color="black" />
                  </div>
                  <Text>{item.text}</Text>
                </Flex>
                <EarnRateTiers productCode={config.productCode} />
                <EarnRateDisclaimer productCode={config.productCode} />
              </div>
            </LandingContentItem>
          ) : (
            <LandingContentItem key={index}>
              <div>
                <Icon name="tick" color="black" />
              </div>
              <Text>{item}</Text>
            </LandingContentItem>
          ),
        )}
      </Grid.Item>
      <Grid.Item colSpan="all" colSpan-md="3-5" colSpan-lg="3-5" rowSpan="1" rowSpan-md="0">
        <Container margin="0 0 3 0" margin-md="0 0 6 0" padding="0">
          <Text textStyle="heading5">Considerations</Text>
        </Container>
        <Container margin="0" margin-md="2 0" padding="0">
          {content[config.productCode]?.cons?.map((item, index) => (
            <LandingContentItem key={index}>
              <Flex>
                <div>
                  <Icon name="cross" color="black" />
                </div>
                <Text>
                  {item} {index === 2 ? learnMoreLink : null}
                </Text>
              </Flex>
            </LandingContentItem>
          ))}
        </Container>
      </Grid.Item>
    </Grid>
  );
};
